var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuardIntervened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.947 9.721h-3.654l-1.56 8.227 3.48.093-.627 6.8 3.68-9.706-2.986.053 1.666-5.467z",
    fill: "#0074C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.04 20.668c-2.547 6.267-9.36 8.587-10.694 8.987-.296.085-.558.043-.647.03-.024-.004-.035-.006-.033-.003-7.746-2.214-10.293-7.934-10.733-9.054a1.359 1.359 0 01-.093-.533V8.442c0-.76.573-1.374 1.293-1.374h.014c5.402-.05 7.721-2.357 8.795-3.426.085-.084.161-.16.231-.227.24-.227.534-.347.853-.347.294 0 .574.107.814.307 3.2 2.88 7.32 3.667 9.053 3.68.707.013 1.28.627 1.28 1.387v11.653c0 .2-.053.4-.133.573zM16 28.255c.84-.24 7.453-2.387 9.8-8.147V8.388c-2.04-.04-6.32-.773-9.76-3.84-3.729 4.004-9.562 3.835-9.83 3.827H6.2v11.707c.413 1.04 2.747 6.146 9.8 8.173z",
    fill: "#0074C2"
  })));
}
export default SvgGuardIntervened;